import { useEffect, useRef } from "react";

export const useClientAppointmentFocusRefresh = (enabled, refresh) => {
  const lastRefresh = useRef(0);
  useEffect(() => {
    if (!enabled) return undefined;
    const onResume = () => {
      if (document.visibilityState === "hidden") return;
      const now = Date.now();
      if (now - lastRefresh.current < 500) return;
      lastRefresh.current = now;
      refresh();
    };
    window.addEventListener("focus", onResume);
    document.addEventListener("visibilitychange", onResume);
    return () => {
      window.removeEventListener("focus", onResume);
      document.removeEventListener("visibilitychange", onResume);
    };
  }, [enabled, refresh]);
};
